import React from 'react';
import { PopupWidget } from 'react-calendly';
import { Helmet } from 'react-helmet-async'

function WebDev() {
    return (

        <>
          <Helmet>
                  <title>Web Development & eCommerce Solutions</title>
                  <meta name="description" content="Our team of experienced developers and digital strategists is committed to delivering high-quality solutions that exceed expectations."/>
                  <link rel="canonical" href="/web_development"/>
                </Helmet>
  
  
                <div>
                {/* Hero Section */}
                <div className="container-fluid bg-primary py-5 mb-5 hero-header">
                    <div className="container py-5">
                        <div className="row justify-content-center py-5">
                            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
                                <h1 className="display-3 text-white animated slideInDown">
                                    Web Development & eCommerce Solutions
                                </h1>
                                <p className="lead text-white mt-4">
                                    Cutting-edge solutions powered by modern technologies
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tech Stack Section */}
                <section className="container py-5 tech-stack">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-5">
                            <h2 className="section-title">Our Technology Stack</h2>
                            <p className="section-subtitle">We use the best tools for optimal performance</p>
                        </div>
                    </div>
                    
                    <div className="row g-4">
                        {/* Frontend Card */}
                        <div className="col-md-6 col-lg-3">
                            <div className="tech-card h-100">
                                <div className="tech-icon react-icon">
                                    <i className="fab fa-react"></i>
                                </div>
                                <h3>Frontend</h3>
                                <p>React with TypeScript</p>
                                <div className="tech-features">
                                    <ul>
                                        <li>Component-based architecture</li>
                                        <li>Type safety</li>
                                        <li>Excellent developer experience</li>
                                        <li>Highly interactive UIs</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        {/* Backend Card */}
                        <div className="col-md-6 col-lg-3">
                            <div className="tech-card h-100">
                                <div className="tech-icon laravel-icon">
                                    <i className="fab fa-laravel"></i>
                                </div>
                                <h3>Backend</h3>
                                <p>Laravel PHP + Node.js</p>
                                <div className="tech-features">
                                    <ul>
                                        <li>Robust authentication</li>
                                        <li>Built-in queue management</li>
                                        <li>Eloquent ORM</li>
                                        <li>Real-time capabilities</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        {/* Database Card */}
                        <div className="col-md-6 col-lg-3">
                            <div className="tech-card h-100">
                                <div className="tech-icon database-icon">
                                    <i className="fas fa-database"></i>
                                </div>
                                <h3>Database</h3>
                                <p>MySQL/PostgreSQL/Supabase</p>
                                <div className="tech-features">
                                    <ul>
                                        <li>Relational data integrity</li>
                                        <li>Excellent performance</li>
                                        <li>Scalable solutions</li>
                                        <li>Project-specific selection</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        {/* Infrastructure Card */}
                        <div className="col-md-6 col-lg-3">
                            <div className="tech-card h-100">
                                <div className="tech-icon cloud-icon">
                                    <i className="fas fa-cloud"></i>
                                </div>
                                <h3>Infrastructure</h3>
                                <p>AWS/DigitalOcean/Vercel</p>
                                <div className="tech-features">
                                    <ul>
                                        <li>Scalable hosting</li>
                                        <li>High availability</li>
                                        <li>Global CDN</li>
                                        <li>Client-owned options</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Solutions Section */}
                <section className="solutions-section py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center mb-5">
                                <h2 className="section-title">Tailored Solutions</h2>
                                <p className="section-subtitle">We match the technology to your needs</p>
                            </div>
                        </div>
                        
                        <div className="row">
                            {/* Dynamic Website Solution */}
                            <div className="col-lg-6 mb-4">
                                <div className="solution-card dynamic-card h-100">
                                    <div className="solution-header">
                                        <i className="fas fa-bolt solution-icon"></i>
                                        <h3>Dynamic Websites</h3>
                                    </div>
                                    <div className="solution-body">
                                        <ul className="solution-features">
                                            <li><i className="fas fa-check-circle"></i> Laravel API backend with Node.js for real-time features</li>
                                            <li><i className="fas fa-check-circle"></i> React with TypeScript for interactive UI</li>
                                            <li><i className="fas fa-check-circle"></i> Headless CMS (Strapi) when needed</li>
                                            <li><i className="fas fa-check-circle"></i> Redis caching & queue systems</li>
                                            <li><i className="fas fa-check-circle"></i> GraphQL/REST APIs for efficient data</li>
                                            <li><i className="fas fa-check-circle"></i> Scalable cloud infrastructure</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Static Website Solution */}
                            <div className="col-lg-6 mb-4">
                                <div className="solution-card static-card h-100">
                                    <div className="solution-header">
                                        <i className="fas fa-rocket solution-icon"></i>
                                        <h3>Static Websites</h3>
                                    </div>
                                    <div className="solution-body">
                                        <ul className="solution-features">
                                            <li><i className="fas fa-check-circle"></i> Next.js static site generation</li>
                                            <li><i className="fas fa-check-circle"></i> Lightweight Laravel APIs if needed</li>
                                            <li><i className="fas fa-check-circle"></i> Simple headless CMS options</li>
                                            <li><i className="fas fa-check-circle"></i> CDN-hosted static assets</li>
                                            <li><i className="fas fa-check-circle"></i> Cost-effective Netlify/Vercel hosting</li>
                                            <li><i className="fas fa-check-circle"></i> Blazing fast performance</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Features Section */}
                <section className="features py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center mb-5">
                                <h2 className="section-title">Our Expertise</h2>
                                <p className="section-subtitle">Comprehensive digital solutions for your business</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div className="feature-card h-100">
                                    <img src="https://f.hubspotusercontent30.net/hubfs/3365633/Custom%20web%20design%20for%20your%20business.jpg" alt="Custom Web Design" className="feature-img" />
                                    <div className="feature-content">
                                        <h3>Custom Web Development</h3>
                                        <p>We build responsive and visually appealing websites that align with your brand identity.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div className="feature-card h-100">
                                    <img src="https://ocdn.eu/images/pulscms/ZjI7MDA_/bb6b0f53264a0ae1d90067153c065aeb.jpg" alt="eCommerce Platform" className="feature-img" />
                                    <div className="feature-content">
                                        <h3>eCommerce Solutions</h3>
                                        <p>Create scalable and secure online stores to provide exceptional shopping experiences.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div className="feature-card h-100">
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcu7U_qmAaPgrRrYjpRcyHompaDAyFvdFTRw&s" alt="SEO Optimization" className="feature-img" />
                                    <div className="feature-content">
                                        <h3>SEO & Digital Marketing</h3>
                                        <p>Improve your visibility and attract organic traffic with our SEO and marketing strategies.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div className="feature-card h-100">
                                    <img src="https://datasciencedojo.com/wp-content/uploads/Data-visualization-in-business-analytics--scaled.jpg" alt="Analytics Integration" className="feature-img" />
                                    <div className="feature-content">
                                        <h3>Analytics & Insights</h3>
                                        <p>Leverage data-driven insights to optimize your online performance and grow your business.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Process Section */}
                <section className="process-section py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center mb-5">
                                <h2 className="section-title">Our Development Process</h2>
                                <p className="section-subtitle">A structured approach to success</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div className="process-step">
                                    <div className="step-number">1</div>
                                    <h3>Discovery</h3>
                                    <p>Understanding your business goals and challenges through detailed consultations.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div className="process-step">
                                    <div className="step-number">2</div>
                                    <h3>Planning</h3>
                                    <p>Crafting a roadmap with detailed wireframes, architecture, and strategies.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div className="process-step">
                                    <div className="step-number">3</div>
                                    <h3>Development</h3>
                                    <p>Building responsive, secure, and user-friendly solutions with modern tech stacks.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div className="process-step">
                                    <div className="step-number">4</div>
                                    <h3>Launch & Support</h3>
                                    <p>Deploying your platform and providing ongoing maintenance and updates.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="cta-section py-5">
                    <div className="container">
                        <div className="cta-box text-center">
                            <h2>Ready to Build Something Amazing?</h2>
                            <p className="mb-4">Let's discuss how we can bring your digital vision to life with the right technology stack.</p>
                            <div className="d-flex justify-content-center gap-3">
                                <button className="btn btn-primary btn-lg">Get a Free Quote</button>
                                <PopupWidget
                                    url="https://calendly.com/nagspros"
                                    rootElement={document.getElementById('root')}
                                    text="Schedule a Consultation"
                                    textColor="#ffffff"
                                    color="#346815FF"
                                    className="btn btn-success btn-lg"
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default WebDev;
